import { useEffect, useState } from "react";
import { defaultHeight, defaultWidth, maxRatio } from "../util/Constants";

export const useWindowScale = () => {
  const [scaleInit, setScaleInit] = useState(false);
  const [ratio, setRatio] = useState(maxRatio);
  const [scale, setScale] = useState(1);

  const [containerLeft, setContainerLeft] = useState(0);
  const [itemLeft, setItemLeft] = useState(0);
  const [itemRight, setItemRight] = useState(0);

  const handleResize = () => {
    const windowRatio = window.innerWidth / window.innerHeight;
    const windowScale = window.innerHeight / defaultHeight;

    setRatio(windowRatio);
    setScale(windowScale);

    setContainerLeft((defaultWidth - window.innerWidth) / 2);

    const diff = (defaultWidth - window.innerWidth / windowScale) / 2;
    if (windowRatio < maxRatio) {
      setItemLeft(diff);
      setItemRight(0);
    } else {
      setItemLeft(0);
      setItemRight(diff);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    setScaleInit(true);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { scaleInit, ratio, scale, containerLeft, itemLeft, itemRight };
};
